import { createSlice } from "@reduxjs/toolkit";

const retryRequestSlice = createSlice({
  name: "retryRequest",
  initialState: {
    isRefreshing: false,
    retryQueue: [],
  },
  reducers: {
    setIsRefreshing: (state, action) => {
      state.isRefreshing = action.payload;
    },
    queueForRetry: (state, action) => {
      state.retryQueue = state.retryQueue.concat(action.payload);
    },
    emptyRetryQueue: (state) => {
      state.retryQueue = [];
    },
  },
});

export const popRetryQueue = () => (dispatch, getState) => {
  let queue = getState().tempInfo.retryRequest.retryQueue;
  dispatch(emptyRetryQueue());
  return queue;
};

export const { setIsRefreshing, queueForRetry, emptyRetryQueue } =
  retryRequestSlice.actions;
export default retryRequestSlice.reducer;
